import routes from '@/router/routes.json'
import api from "@/api"

let localhost 	= location.hostname;
let port 		= process.env.VUE_APP_PORT_API || `80`; //this.$port;

if (process.env.NODE_ENV == `development`) {
		port 	= process.env.VUE_APP_PORT_API 		||  `80`; //this.$port;		
	}else{
		// console.log("process.env.NODE_ENV", process.env);
		port 	= process.env.VUE_APP_PORT_API 		|| 	`80`; //this.$port;		
	}

if (localhost == `.`) {
	localhost = `localhost`;
}

let proto = 'http://';
if (api) {
	proto = api.protocol;
}

const API = proto + localhost + ':' + port;


/*
	req: {
		type:  <name route>
		opt: 	other argments, example { where: id }
	}
*/
class route{
	get_route(type,opt){
		if (routes && routes.length > 0) {
			let URL = '';
			const find = routes.some( function(arr, idx_arr){
				if (arr.type == type && arr.opts == opt ) {
					URL = arr.url;
					return true;
				}
			})
			if (find) {
				return URL;
			}
			return false
		}
	}

	create(req){
		
	}
	
	get(req){

	}

	get_list(req){

	}

	update(req){

	}

	delete(req){

	}



};

export default new route;